import { render } from "./InicioPago.vue?vue&type=template&id=fe46e92c"
import script from "./InicioPago.vue?vue&type=script&lang=js"
export * from "./InicioPago.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__